import React from "react";
import "./CarLoan.css";
import Banklist from "../common/Banklist/Banklist";
import LoanForm from "../common/Form/Form";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";
import { useNavigate } from "react-router-dom";

export default function TwoWheeler() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="car-container">
        <section className="lap-hero">
          <div className="lap-container">
            <div className="lap-video">
              <img
                src="/images/b.png"
                alt="Two Wheeler Loan"
                className="hero-video"
              />
            </div>

            <div className="lap-content">
              <h1>
                Ride Your Dream Bike with Easy and Affordable
                <span> Two Wheeler Loan!</span>
              </h1>

              <ul className="lap-points">
                <li>✔ Instant Loan Approval</li>
                <li>✔ Low Interest Rates</li>
                <li>✔ Flexible EMI Options</li>
              </ul>

              <p>
                Buying your dream bike or scooter is now easier with our Two
                Wheeler Loan solutions. Whether you are planning to buy a new
                motorcycle or a scooter, we help you get quick approvals,
                affordable interest rates, and minimal documentation.
              </p>
            </div>
          </div>
        </section>
        <section className="car-loan-benefits">
          <div className="container">
            <div className="section-titlee">
              <h2>
                Why Choose Krishana Finconcept for Your
                <span> Two Wheeler Loan?</span>
              </h2>
              <p>
                We make your bike ownership journey simple, fast, and
                hassle-free with flexible financing options and quick approvals.
              </p>
            </div>

            <div className="benefits-grid">
              <div className="benefit-card">
                <h4>Low Interest Rates</h4>
                <p>
                  Get affordable two wheeler loan interest rates that make your
                  monthly EMIs easy to manage.
                </p>
              </div>

              <div className="benefit-card">
                <h4>Zero Prepayment Charges</h4>
                <p>
                  Repay your loan early without worrying about any additional
                  prepayment or foreclosure fees.
                </p>
              </div>

              <div className="benefit-card">
                <h4>Simple Digital Application</h4>
                <p>
                  Apply for your bike loan online with minimal documentation and
                  quick approval process.
                </p>
              </div>

              <div className="benefit-card">
                <h4>Instant Eligibility Check</h4>
                <p>
                  Check your two wheeler loan eligibility instantly without
                  impacting your credit score.
                </p>
              </div>

              <div className="benefit-card">
                <h4>Quick Loan Disbursement</h4>
                <p>
                  Get fast loan processing so you can ride your dream bike
                  without long waiting times.
                </p>
              </div>

              <div className="benefit-card">
                <h4>Flexible EMI Plans</h4>
                <p>
                  Choose repayment tenures and EMI options that suit your
                  financial needs comfortably.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="homeload-main-section homeloan-section modern-variant unique-hero-design full-width-layout">
          <div className="homeloan-hero-text animated-entrance">
            {/* 1. Badge */}
            <div className="badge-glow animated-item">Your Ride, Your Way</div>

            {/* 2. Main Title */}
            <h1 className="title animated-item">
              Ride Your Dream Bike With Our <span>Two Wheeler Loans!</span>
            </h1>

            {/* 3. Features Pills */}
            <div className="features-flex animated-item">
              <div className="feat-pill">
                <span className="icon">✔</span> Up to 95% Financing
              </div>
              <div className="feat-pill">
                <span className="icon">✔</span> Instant Sanction
              </div>
              <div className="feat-pill">
                <span className="icon">✔</span> Lowest Processing Fees
              </div>
            </div>

            {/* 4. Description Body */}
            <div className="content-body animated-item">
              <p className="subtitle">
                Commute with ease and style.{" "}
                <strong>Krishana Finconcept</strong> offers quick and easy Two
                Wheeler Loans for a wide range of motorcycles and scooters,
                ensuring you never have to wait to start your journey.
              </p>

              <p className="subtitle">
                We provide attractive interest rates and flexible repayment
                tenures tailored to your monthly income. Whether it’s for daily
                commuting or your passion for biking, we have a plan that fits
                your budget.
              </p>

              <p className="subtitle">
                With a completely digital process and minimal documentation, we
                make sure you get your keys faster than ever. No hidden costs,
                just transparent and friendly financing.
              </p>
            </div>

            {/* 5. Action Button */}
            <div className="cta-wrapper animated-item">
              <button
                className="high-conversion-btn"
                onClick={() => {
                  navigate("/services/23", { state: { scrollToApply: true } });
                }}
              >
                <span className="btn-text">Apply For Bike Loan</span>
                <div className="btn-glow-shimmer"></div>
              </button>
            </div>
          </div>
        </section>
        <TestimonialsSection />

        <Services
          slug="23"
          title="Two Wheeler Loan EMI Calculator – Calculate Your Monthly EMI Online"
        />
      </div>
    </div>
  );
}
